// src/pages/TreeFarm.js
import React from 'react';
import Navbar from '../components/Navbar';
import { Link } from 'react-router-dom';
import '../styles/treeFarm.css';
import TreeFarmComponent from '../components/TreeFarmComponent';
// import TreeCatalogSection from '../components/TreeCatalogSection';
// import { treeCatalog } from '../data/treeCatalog'; 
import CTASection from '../components/CTASection';

const TreeFarm = () => {

   const handleFlipCard = (e) => {
    if ('ontouchstart' in window) {
      e.currentTarget.classList.toggle('flipped');
    }
  };

  return (
    <div className="treefarm-page">
      <Navbar />

      {/* Hero Section */}
      <section className="treefarm-hero">
        <div>
          <img
            src="/images/tree/treeHeroImage3.jpg"
            alt="All Seasons Tree Farm"
            className="hero-image"
            loading="eager"
            decoding="async"
          />
        </div>
        <div className="treefarm-hero-overlay">
          <div className="treefarm-hero-content">
            <h1 className="treefarm-hero-title">Welcome to Our Tree Farm</h1>
            <p className="treefarm-hero-subtitle">
              30+ acres of premium trees grown in the Wood River Valley
            </p>
            <Link to="mailto:info@allseasons.info">
                    <button
                      className="btn-cta"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textTransform: "uppercase" }}
                    >
              Request A Consultation
               </button>
            </Link>
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="intro-section-bg-white">
        <div className="section-inner text-center">
          <h2 className="section-title">Idaho's Premier Tree Farm and Nursery</h2>

         <TreeFarmComponent
  copy={{
    // keep client voice exactly
    longLead:
      "The Wood River Valley's distinct climate is part of what makes this place so exceptional. Yet, this natural beauty comes with unique horticultural challenges—only select species of trees, shrubs, and flowers truly thrive here. Traditionally, trees brought in from outside the region struggle to adapt, often compromising their health and longevity.",
    longSupport:
      "That's why we've cultivated a more thoughtful approach: a dedicated tree farm right here in the heart of the Wood River Valley. By nurturing trees from an early age in our local conditions, we ensure each one is perfectly acclimated before it ever reaches your landscape. The result is healthier trees that last longer and look better, season after season.",
    moreFull:
      "Our curated selection includes everything from timeless evergreens like the Bristlecone Pine to striking seasonal varieties such as the Autumn Purple Ash. With over 50 unique species and sizes to choose from, there's something to complement every landscape vision. For a complete list of available trees, contact us today—we're happy to help you find the perfect fit.",
    ctaPrimary: null, // Disable the button
    strip1: "/images/tree/treeFarm/treeFPineLovely.JPG",
    strip2: "/images/treefarm/strip-2.jpg",
    strip3: "/images/treefarm/strip-3.jpg",
  }}
/>
        </div>
      </section>

       {/* Gallery Section - Tree Farm & Team */}
<section className="section bg-white">
  <div className="section-inner">
    <h2 className="section-title text-center">Life at the Tree Farm</h2>
    <p className="section-intro text-center">
      From sunrise plantings to careful cultivation, our dedicated team ensures 
      every tree receives expert care throughout its journey.
    </p>
    
    <div className="tf-gallery">
      <div className="tf-gallery-item tf-gallery-item--wide">
        <img 
          src="/images/tree/treeFarm/treeFMultiPath.JPG" 
          alt="Aerial view of tree nursery rows"
        />
        <div className="tf-gallery-caption">30 acres of meticulously maintained tree rows</div>
      </div>
      
      <div className="tf-gallery-item">
        <img 
          src="/images/tree/treeFarm/treeFFullSmall.JPG" 
          alt="Team members planting young trees"
        />
        <div className="tf-gallery-caption">Spring planting season</div>
      </div>
      
      <div className="tf-gallery-item">
        <img 
          src="/images/tree/treeFarm/treeFLarge.JPG" 
          alt="Customer selecting trees with staff"
        />
        <div className="tf-gallery-caption">Personal tree selection consultations</div>
      </div>
      
      <div className="tf-gallery-item tf-gallery-item--tall">
        <img 
          src="/images/tree/treeFarm/treeFTallThinYoung.JPG" 
          alt="Mature evergreen specimen"
        />
        <div className="tf-gallery-caption">25-foot Blue Spruce ready for transplant</div>
      </div>
      
      <div className="tf-gallery-item">
        <img 
          src="/images/tree/treeFarm/treeFpath.JPG" 
          alt="Loading large tree with specialized equipment"
        />
        <div className="tf-gallery-caption">Specialized equipment for safe transport</div>
      </div>
      
      <div className="tf-gallery-item">
        <img 
          src="/images/tree/treeFarm/treeFMultiPine.JPG" 
          alt="Team member pruning trees"
        />
        <div className="tf-gallery-caption">Expert pruning ensures perfect form</div>
      </div>
      <div className="tf-gallery-item">
  <img 
    src="/images/tree/treeFarm/treeFPineMassPath.JPG" 
    alt="Morning dew on young saplings"
  />
  <div className="tf-gallery-caption">Fresh growth in our sapling section</div>
</div>
      
      <div className="tf-gallery-item tf-gallery-item--wide">
        <img 
          src="/images/tree/treeFarm/treeFPineLovely.JPG" 
          alt="Tree farm in fall colors"
        />
        <div className="tf-gallery-caption">Spectacular fall colors in our deciduous section</div>
      </div>
      
      {/* New images to fill empty space */}
      <div className="tf-gallery-item">
        <img 
          src="/images/tree/treeFarm/treeFDifferent.JPG" 
          alt="Irrigation system in action"
        />
        <div className="tf-gallery-caption">Modern irrigation keeps trees healthy year-round</div>
      </div>
      
      <div className="tf-gallery-item">
        <img 
          src="/images/tree/treeFarm/treeFLightTree.JPG" 
          alt="Seedling greenhouse"
        />
        <div className="tf-gallery-caption">Starting the next generation in our greenhouse</div>
      </div>
      <div className="tf-gallery-item tf-gallery-item--wide">
  <img
    src="/images/tree/treeFarm/treeFXmasTree.JPG"
    alt="Sunset over the tree farm"
  />
  <div className="tf-gallery-caption">Golden hour at All Seasons Tree Farm</div>
</div>

    </div>
  </div>
</section>

    {/* Full Tree Catalog */}
{/* <section className="section bg-soft-stone">
  <div className="section-inner">
    <h2 className="section-title text-center">Our Complete Tree Inventory</h2>
    <p className="section-intro text-center">
      Browse our extensive collection of trees, each carefully selected and grown 
      for optimal performance in our mountain climate.
    </p>
   <div className="tree-catalog-wrapper">
  <TreeCatalogSection limit={7} />
  <TreeCatalogSection 
    items={treeCatalog.slice(7)} 
  />
</div>
  </div>
</section> */}

      {/* Services Flip Grid */}
      <section className="section bg-white">
      <h2 className="section-title">Your Complete Tree Solution</h2>
          <div className="tree-services-grid">
            <div className="service-flip-card" onClick={handleFlipCard}>
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <img
                    src="images/tree/treeFarm/treeFarmLandscape.JPG"
                    alt="Tree Selection"
                    className="service-bg-image"
                  />
                  <h3 className="service-title-overlay">Expert Selection</h3>
                </div>
                <div className="flip-card-back">
                  <div className="flip-card-content">
                    <h3>Expert Selection</h3>
                    <p>Choose from hundreds of trees at our nursery</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="service-flip-card" onClick={handleFlipCard}>
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <img
                    src="images/tree/treeAS.jpg"
                    alt="Delivery"
                    className="service-bg-image"
                  />
                  <h3 className="service-title-overlay">Professional Delivery</h3>
                </div>
                <div className="flip-card-back">
                  <div className="flip-card-content">
                    <h3>Professional Delivery</h3>
                    <p>Safe transport of mature specimens up to 30 feet tall</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="service-flip-card" onClick={handleFlipCard}>
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <img
                    src="images/tree/treeInstallation.png"
                    alt="Installation"
                    className="service-bg-image"
                  />
                  <h3 className="service-title-overlay">Expert Installation</h3>
                </div>
                <div className="flip-card-back">
                  <div className="flip-card-content">
                    <h3>Expert Installation</h3>
                    <p>Proper planting ensures healthy growth for decades</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="service-flip-card" onClick={handleFlipCard}>
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <img
                    src="images/tree/treeMaintenance1.jpg"
                    alt="Tree Care"
                    className="service-bg-image"
                  />
                  <h3 className="service-title-overlay">Ongoing Care</h3>
                </div>
                <div className="flip-card-back">
                  <div className="flip-card-content">
                    <h3>Ongoing Care</h3>
                    <p>Pruning, health assessments, and maintenance</p>
                  </div>
                </div>
              </div>
            </div>
          </div>{/* /.tree-services-grid */}
    
      </section>

      {/* CTA Section */}
     <CTASection 
  title="Experience the Difference"
  subtitle="See why landscape professionals and homeowners choose All Seasons Tree Farm for their most important projects"
  galleryLink="/Gallery/treefarm"
  showEmergency={false}
/>
    </div>
  );
};

export default TreeFarm;